import { Box, Grid, Typography } from "@mui/material";
import { useGlobalSearch } from "api/globalSearch";
import { useAppSelector } from "app/hooks";
import { useMessage } from "hooks/intl";
import { memo, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { selectCurrentStoreData } from "reduxState/currentStoreData/currentStoreDataSlice";
import { selectGlobalSearch } from "reduxState/search/search";
import { CategoryDetailsType } from "types/sidebar";
import { Category } from "./Category";
import { useStyles } from "./styles";

interface Props {
  searchValue: string;
  setIsSearching: (val: boolean) => void;
  isInitialLoad: boolean;
  isSearching: boolean;
}

type SearchResults = CategoryDetailsType[];

export const SearchList = memo(
  ({ searchValue, setIsSearching, isInitialLoad, isSearching }: Props) => {
    const [results, setResults] = useState<SearchResults>([]);
    const { message } = useMessage();
    const classes = useStyles();
    const { searchGlobal } = useGlobalSearch();
    const { code } = useAppSelector(selectCurrentStoreData);
    const globalSearchData = useAppSelector(selectGlobalSearch);

    useEffect(() => {
      if (isInitialLoad) return;
      setIsSearching(true);
      searchGlobal(searchValue).then((res) => {
        setIsSearching(false);
        return setResults(
          res.filter((category) => category.items.length > 0) as SearchResults,
        );
      });

      // eslint-disable-next-line
    }, [searchValue]);

    const isAnyResult = results.some((res) => res.items.length > 0);
    const lastSearchedItems = globalSearchData[code];
    const areLastSearchedItems = lastSearchedItems?.length > 0;

    return (
      <div className={classes.categoryList}>
        {isInitialLoad && areLastSearchedItems ? (
          <div>
            <Typography className={classes.lastSearchTitle}>
              {message({ id: "lastSearch" })}
            </Typography>
            <Grid container>
              {lastSearchedItems.map((item) => {
                return (
                  <Grid
                    key={item.link}
                    item
                    xs={12}
                    className={classes.linkWrapper}
                  >
                    <NavLink
                      to={item.link}
                      target="_blank"
                      className={classes.link}
                    >
                      <Typography className={classes.linkName}>
                        {item.label}
                      </Typography>
                      <Typography
                        className={classes.linkDesc}
                        textTransform="lowercase"
                      >
                        {message({ id: "in" })}
                      </Typography>
                      <Typography
                        className={classes.linkDesc}
                        textTransform="capitalize"
                      >
                        {message({ id: item.category })}
                      </Typography>
                    </NavLink>
                  </Grid>
                );
              })}
            </Grid>
          </div>
        ) : isAnyResult ? (
          results.map((category) => (
            <Category category={category} key={category.type} />
          ))
        ) : !isSearching && !!searchValue ? (
          <Box p={12} textAlign="center">
            {message({ id: "noResultsFor" }, { value: searchValue })}
          </Box>
        ) : null}
      </div>
    );
  },
);
